// Task catalog for the clip task picker (GET /api/tasks, console cookie auth).

import { useQuery } from "@tanstack/react-query";
import { apiFetch } from "./client";
import type { TaskRead } from "./types";

/** The active task catalog in curated display order. Changes rarely — cached for the session. */
export function useTasks() {
  return useQuery({
    queryKey: ["tasks"],
    queryFn: () => apiFetch<TaskRead[]>("/api/tasks"),
    staleTime: Infinity,
    gcTime: 1000 * 60 * 60,
  });
}
